import { Box, Button, IconButton, Typography } from '@mui/material';
import { CloudUpload, PhotoCamera } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { IField } from '../../../models/form/form';

interface IFieldProps {
    field: IField;
}
const ImageUploaderField = ({ field }: IFieldProps) => {
    const { t } = useTranslation(['common', 'form']);
    return (
        <Box width={"100%"}>
            <Box marginBottom={1}>
                <Typography display="inline">{field.text.trim()}</Typography>
                {field.required && <Typography display="inline" color="error"> *</Typography>}
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" border="1px dashed #ccc" padding={1}>
                <Box>
                    <input
                        type="file"
                        accept="image/*"
                        multiple
                        style={{ display: 'none' }}
                    />
                    <Button>
                        <CloudUpload /> <Typography variant="body2" fontWeight={"bold"} marginLeft={1}>{t("form:chooseFile")}</Typography>
                    </Button>
                </Box>

                <Box>
                    <input
                        type="file"
                        accept="image/*"
                        multiple
                        capture="environment"
                        style={{ display: 'none' }}
                    />
                    <IconButton color='primary'>
                        <PhotoCamera />
                    </IconButton>
                </Box>

            </Box>
            <Typography variant="body2" color="textSecondary">{t('form:maxImages')}</Typography>
        </Box>
    );
};

export default ImageUploaderField;
